import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { LayoutContext } from '@landsbankinn/slices/components/contexts/LayoutContext';
import { Logo, device, Close, sronly } from '@landsbankinn/ui';
import Link from 'next/link';
import React, { useContext } from 'react';
import messages from '../navigation/navigation.res';

const LogoWrapper = styled.a`
  cursor: pointer;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -5px;
`;

const Host = styled.div`
  position: relative;
  z-index: 30;
  height: 80px;
  padding: 0 16px;
  padding-top: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: ${(props) => props.theme.gradients.primary};
`;

const Line = styled.div`
  width: 22px;
  height: 1px;
  background-color: white;
  margin-bottom: 5px;
`;

const MenuIcon = styled.a`
  width: 64px;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 10px;
`;

const Menu = (props: any) => (
  <MenuIcon {...props} aria-label="menu">
    <Line />
    <Line />
    <Line style={{ width: 12, marginRight: 10 }} />
  </MenuIcon>
);

const SrOnly = styled.span`
  ${sronly}
`;

const Extra = styled.div`
  height: 80px;
  margin-left: auto;
  display: flex;
  align-items: center;
  margin-top: -3px;
  margin-right: 4px;
`;

const ExtraLink = styled.a<{ close?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.close ? '0 0 0 12px' : '0 12px;')};
  height: 80px;
  @media ${device.tablet} {
    padding: 0px 12px;
  }
`;

const CloseIcon = styled.div`
  border-radius: 32px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
`;

export function MobileHeader() {
  const { r } = useResource();
  const { isNavigationOpen, setIsNavigationOpen } = useContext(LayoutContext);
  return (
    <Host>
      <Link href="/">
        <LogoWrapper
          href="/"
          title="Forsíða"
          onClick={() => setIsNavigationOpen(false)}
        >
          <Logo style={{ width: 32, height: 32 }} />
        </LogoWrapper>
      </Link>

      {isNavigationOpen ? (
        <Extra>
          {/*<ExtraLink
            href={locale === 'is' ? '/en' : '/'}
            title={r(messages.language)}
          >
            <Language />
            <SrOnly>{r(messages.language)}</SrOnly>
          </ExtraLink>
          */}
          {/*<Link href="/leit" as="/leit">
            <ExtraLink href="/leit" title={r(messages.search)}>
              <SearchIcon />
              <SrOnly>{r(messages.search)}</SrOnly>
            </ExtraLink>
      </Link>*/}
          {/*   <DropDown isTemp icon={<SearchIcon />}>
            <p style={{ padding: '7px 5px' }}>Í vinnslu</p>
          </DropDown> */}
          <ExtraLink
            close={true}
            href="#"
            title={r(messages.closeNavigation)}
            onClick={() => setIsNavigationOpen(false)}
          >
            <CloseIcon>
              <Close />
            </CloseIcon>
            <SrOnly>{r(messages.closeNavigation)}</SrOnly>
          </ExtraLink>
        </Extra>
      ) : (
        <>
          <Menu href="#" onClick={() => setIsNavigationOpen(true)} />
        </>
      )}
    </Host>
  );
}
